
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke124aRequest, Sgke124aResponse, Sgke124aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke124aService {

  /**
   * コンストラクタ
   * @param {Sgke124aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke124aService
   */
  constructor(
    public service: Sgke124aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE124A_入金突合報告API呼び出し
   * @param {Sgke124aRequest} request 
   * @returns {Observable<Sgke124aResponse>}
   * @memberof UsedSgke124aService
   */
  public doSgke124a(request: Sgke124aRequest): Observable<Sgke124aResponse> {
    return this.service.sgke124aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE124A');
          return throwError(err.message);
        })
      );
  }

}
